import { CallerTypeQuestionValue } from '@dte/otw-azure-functions/src/report/questions/reporter/CallerTypeQuestion';
import { ReportQuestion } from '@dte/otw-azure-functions/src/report/questions/ReportQuestion';

import { useReportAnswerValueSelected } from '../../../_atoms/draftReport/stepData';

export function useIsPoliceFire(): boolean {
	return useReportAnswerValueSelected(ReportQuestion.CallerType, CallerTypeQuestionValue.PoliceFire) === true;
}
